import axios from "axios";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

// Add a request interceptor to include the token
apiClient.interceptors.request.use((config) => {
  const token = getTokenFromCookies();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Helper to retrieve token from cookies
function getTokenFromCookies() {
  const cookies = document.cookie.split(";");
  const tokenCookie = cookies.find((cookie) =>
    cookie.trim().startsWith("authToken=")
  );
  // console.log(tokenCookie);

  if (tokenCookie) {
    // console.log(tokenCookie.username);

    return tokenCookie.split("=")[1];
  }
  return null;
}

// Make an API request
export const AuthRequest = async (arg) => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_BASE_URL}/${arg.subLink}`
    );
    // console.log("API response:", response.data);
    return response;
  } catch (error) {
    return error;
    // console.error("API error:", error.response || error.message);
  }
};
